import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
  memo,
  useCallback,
  useReducer,
} from "react";

// Provider
import { AppContext } from "../../components/AppProvider";

// Utils
import { _O } from "../../modules/utils";
import { NativeAction } from "../../modules/utils/HandleWs";
import { userHabit } from "../../modules/utils/UserHabit";

// UI
import { ContainerNew, SubMenu, RightMenu, ContainerNoBottom } from "../Layout";

import { RightMenuLayer } from "./RightMenuLayer";
import LocationTerms, { LocationTermsHist } from "./TermsDetail/LocationTerms";
import PrivateTerms, { ContentsPrivate, ContentsPrivateHist } from "./TermsDetail/PrivateTerms";
import ServiceTerms, { ServiceTermsHist } from "./TermsDetail/ServiceTerms";
import styled from "styled-components";
import { ScrollToTop } from "../common/ScrollToTop/ScrollToTop";
import { Private_20231220 } from "./TermsDetail/PrivateTerms/20231220";

export default props => {
  const { userinfo, cfg, phonecfg } = useContext(AppContext);
  // props.match.params.target
  // 이용약관: service
  // 개인정보약관: priv
  // 위치정보약관: geo

  const titleText =
    props.match.params.target === "service" ||
    props.match.params.target === "service20231220"
      ? "서비스이용약관"
      : props.match.params.target === "priv" ||
        props.match.params.target === "priv2" ||
        props.match.params.target === "priv3"
      ? "개인정보처리방침"
      : "위치기반서비스이용약관";

  useEffect(() => {
    userHabit(phonecfg, "TP100");
    NativeAction(phonecfg, "statusColor", "#A5AEE4");
  }, [phonecfg.version]);

  return (
    <Fragment>
      <ScrollToTop />
      <ContainerNew Title={titleText} dark={"dark"} bottomHide={true}>
        <div className="contents">
          <div className="sub-contents">
            {props.match.params.target === "service" ? (
              <ServiceTermsHist />
            ) : props.match.params.target === "service20231220" ? (
              <ServiceTerms />
            ) : props.match.params.target === "priv" ? (
              <ContentsPrivateHist />
            ) : props.match.params.target === "priv2" ? (
              <ContentsPrivate />
            ) : props.match.params.target === "priv3" ? (
              <Private_20231220 />
            ) : (
              <LocationTermsHist />
            )}
          </div>
        </div>
      </ContainerNew>
    </Fragment>
  );
};
